<template>
  <div style="margin: 0px auto">
    <div class="main">
      <HomeHeader />
      <div style="margin: auto">
        <img
          v-if="COUNTRY_CODE === 'US'"
          width="20px"
          style="margin: 5px"
          src="https://catamphetamine.gitlab.io/country-flag-icons/3x2/US.svg"
        />
        <input
          class="form shadow-5"
          style="width: 150px"
          type="text"
          v-model="input_zipcode"
          placeholder="Postal Code"
          list="zipcodes"
        />
        <datalist id="zipcodes">
          <option v-for="(zipcode, index) in zipcodesList" :key="index">
            {{ zipcode }}
          </option>
        </datalist>
        <br />
      </div>

      <!-- ERROR MESSAGING  -->
      <div id="errormessage"></div>
      <!-- Redirect Loader -->
      <v-overlay :value="redirectLoader">
        <div class="loader">Loading...</div>
        <small>Redirecting .....</small>
        <div id="redirect_loader"></div>
      </v-overlay>
      <!-- google recaptcha added -->
      <div class="row justify-content-center" style="margin-top: 40px">
        <invisible-recaptcha
          sitekey="6LeGZNEZAAAAANSEr40O2tnjd5UGN31gYQu3PjDQ"
          v-bind:disabled="!zipCodeValid()"
          :callback="submitted"
          class="btn btn-primary btn-grad"
          type="submit"
          id="submit_button"
        >
          Container Prices
          <v-icon color="#ffffff"> mdi-arrow-right-thick </v-icon>
        </invisible-recaptcha>
      </div>
      <!-- google recaptcha ended -->
      <!--Loader starts -->
      <v-dialog v-model="loader" hide-overlay persistent top width="500px">
        <v-card
          style="
            background: linear-gradient(#6dbe45, #3b701e);
            border-radius: 20px;
          "
        >
          <br />
          <textarea
            class="marketsLoader"
            readonly
            type="text"
            rows="2"
            cols="40"
            :value="loaderMessage"
          />
          <v-card-text>
            <div class="loader">Loading...</div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--Loader ends -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import { v4 as uuid_v4 } from "uuid";
import InvisibleRecaptcha from "vue-invisible-recaptcha";
import * as types from "@/store/types";
import HomeHeader from "./pages/HomeHeader.vue";

export default {
  name: "Home",
  components: {
    "invisible-recaptcha": InvisibleRecaptcha,
    HomeHeader,
  },
  computed: {
    ...mapGetters({
      COUNTRY_CODE: types.COUNTRYCODE,
      VUEX_ZIPCODE: types.ZIPCODE,
      CART: types.CART_LIST,
      terms_conditions: types.TERMSCHECKBOX,
      predelivery: types.PREDELIVERYANSWERS,
      prepickup: types.PREPICKUPANSWERS,
      containers_list: types.CONTAINER_LIST,
    }),
  },
  data() {
    return {
      input_zipcode: "",
      loader: false,
      loaderMessage: "",
      markets: [],
      zipcodesList: [],
      reCAPTCHA_token: false,
      redirectLoader: false,
    };
  },
  mounted() {
    this.input_zipcode = this.$route.query.postal_code || this.VUEX_ZIPCODE;
    this.zipcodesList = JSON.parse(localStorage.getItem("zipcodesList"));
    //save user ID in localstorage unique to each client to save feedback in the back-end.
    if (!("userFeedSessionId" in localStorage))
      localStorage.userFeedSessionId = uuid_v4();
  },
  methods: {
    ...mapActions({
      updateZipCode: types.ACTIONS_UPDATE_ZIPCODE,
      updateContainersList: types.ACTIONS_UPDATE_CONTAINER_LIST,
      resetCart: types.ACTIONS_UPDATE_RESETCART,
      updateTermsConditions: types.ACTIONS_UPDATE_TERMSCHECKBOX,
      updateCscTerms: types.ACTIONS_UPDATE_CSC_TERMS,
      updateDoorDirection: types.ACTIONS_UPDATE_DELIVERY_DOORDIRECTION,
      updateDeliverySpace: types.ACTIONS_UPDATE_DELIVERY_SPACE,
      updateRustAcknowledge: types.ACTIONS_UPDATE_DELIVERY_RUSTACKNOWLEDGE,
      updateDeliveryInstructions: types.ACTIONS_UPDATE_DELIVERY_INSTRUCTIONS,
      updateNonAcceptableDates:
        types.ACTIONS_UPDATE_DELIVERY_NONACCEPTABLEDATES,
      updateDeliverySurface: types.ACTIONS_UPDATE_DELIVERY_SURFACETYPE,
      updatePickupRustAcknowledge: types.ACTIONS_UPDATE_PICKUP_RUSTACKNOWLEDGE,
      updatePickupInspection: types.ACTIONS_UPDATE_PICKUP_INSPECTION,
      updatePickupInstructions: types.ACTIONS_UPDATE_PICKUP_INSTRUCTIONS,
    }),
    zipCodeValid() {
      const US_Regex = RegExp("^[0-9]{5}$");
      const Canada_Regex = RegExp("^[A-Za-z0-9]{3}[ ]?[A-Za-z0-9]{3}$");

      return (
        Canada_Regex.test(this.input_zipcode) ||
        US_Regex.test(this.input_zipcode)
      );
    },
    submitted(response) {
      /*resposne will have the reCAPTCHA token.
      If token is null or empty do nothing.*/
      if (!response) return;
      document.getElementById("errormessage").innerHTML = "";
      localStorage.zipcode = this.input_zipcode;
      this.updateZipCode(this.input_zipcode);
      axios
        .get(
          "https://8bikxb8159.execute-api.us-west-2.amazonaws.com/prod/sale-prices",
          {
            headers: {
              "X-API-Key": "o6oTAepBiP5JngNwbFdLu6MN6HMYLNPN6IYQxedV",
            },
            params: {
              postal_code: this.input_zipcode,
              country: this.COUNTRY_CODE,
            },
          }
        )
        .then((response) => this.addhaulerdetails(response.data))
        .catch((err) => {
          console.log(err);
          this.loader = false;
        });

      this.getLoaderStarted(); //get loading message started
    },
    addhaulerdetails(response) {
      if (!("data" in response)) {
        this.loader = false;
        let errorMessage = response.responses[0].elements[0].replace(
          "Error:",
          ""
        );
        let extractedUrls = errorMessage.match(/\bhttps?:\/\/\S+/gi);
        if (extractedUrls && extractedUrls.length > 0)
          this.handleRedirection(
            extractedUrls[0].replaceAll("'", ""),
            errorMessage
          );
        else document.getElementById("errormessage").innerHTML = errorMessage;
      } else {
        /*reset values to default, maintain zipcodes List in local storage,
         maintain LocalStorage for cart, zipcode, termsnconditions */
        this.zipcodesLocalStorage();
        this.resetDefault();
        this.updateContainersList(response.data);
        this.markets = response.data.markets;
        this.maintainLocalStorage();
        this.getMarketsLoader();
        this.maintainSessionStorage();
      }
    },
    handleRedirection(url, errorMessage) {
      this.redirectLoader = true;
      setTimeout(() => {
        document.getElementById("redirect_loader").innerHTML = errorMessage;
      }, 100);
      setTimeout(() => {
        this.redirectLoader = false;
        window.location.href = `${url}?postal_code=${this.input_zipcode}`;
      }, 3000);
    },
    resetDefault() {
      //Reset values to default
      this.showerrormessage = false;
      this.resetCart();
      this.updateTermsConditions(false);
      this.updateCscTerms(false);
      this.updateDoorDirection(null);
      this.updateDeliverySpace(null);
      this.updateRustAcknowledge(null);
      this.updateDeliveryInstructions("");
      this.updateNonAcceptableDates([]);
      this.updateDeliverySurface("");
      this.updatePickupRustAcknowledge(null);
      this.updatePickupInspection(null);
      this.updatePickupInstructions("");
    },
    getLoaderStarted() {
      this.loader = true;
      this.loaderMessage = "Searching your area for best prices...";
    },
    getMarketsLoader() {
      var count = 0;
      for (var i = 0; i < this.markets.length; i++) {
        setTimeout(() => {
          this.setMessage(count);
          count += 1;
        }, i * 1200);
      }
    },
    setMessage(count) {
      document.getElementsByClassName("marketsLoader")[0].value =
        "Comparing prices from " + this.markets[count] + "...";
      if (count === this.markets.length - 1) {
        setTimeout(() => {
          this.loader = false;
          this.navigate();
        }, 1200);
      }
    },
    navigate() {
      this.$router.push("/purchase");
    },
    zipcodesLocalStorage() {
      /*check if zipcodeList present  in localstorage, if not check if zipcode is present already in the list, 
      if not check if the size is less than 5. If not change the least recently used zipcode(Queue - First In First Out)*/
      if (!("zipcodesList" in localStorage))
        localStorage.setItem(
          "zipcodesList",
          JSON.stringify([this.input_zipcode])
        );
      else {
        var zipcodesList = JSON.parse(localStorage.getItem("zipcodesList"));
        if (zipcodesList.includes(this.input_zipcode)) return;
        else {
          if (zipcodesList.length < 5) zipcodesList.push(this.input_zipcode);
          else {
            zipcodesList.shift();
            zipcodesList.push(this.input_zipcode);
          }
          localStorage.setItem("zipcodesList", JSON.stringify(zipcodesList));
        }
      }
    },
    maintainLocalStorage() {
      const containers_list = JSON.stringify(this.containers_list);
      localStorage.setItem("containers_list", containers_list);
      const containerdetailes = JSON.stringify(this.CART);
      localStorage.setItem("containerdetailes", containerdetailes);
      const termsCheckbox = JSON.stringify(this.terms_conditions);
      localStorage.setItem("termsCheckbox", termsCheckbox);
    },
    maintainSessionStorage() {
      //change predelivery survey answers to default
      const predelivery = JSON.stringify(this.predelivery);
      sessionStorage.setItem("predelivery", predelivery);
      //change prepickup survey answers to default
      const prepickup = JSON.stringify(this.prepickup);
      sessionStorage.setItem("prepickup", prepickup);
    },
  },
  watch: {
    reCAPTCHA_token: function (newValue) {
      //Change the reCAPTCHA to false after 1 second as the token will expire after one second.
      if (newValue) {
        setTimeout(() => {
          this.reCAPTCHA_token = false;
        }, 60 * 1000);
      }
    },
  },
};
</script>

<style scoped>
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css);

.main {
  display: block;
  padding: 10px;
  position: relative;
}

textarea {
  width: 90%;
  border: none;
  outline: none;
  resize: none;
}

.marketsLoader {
  font-size: 15px;
  text-align: center;
  color: #ffffff;
}

.form {
  border-radius: 25px;
  border-color: grey;
  margin: auto;
  width: 25%;
  padding: 10px;
  background-color: rgb(255, 255, 255);
  text-align: center;
  font-size: 18px;
}

input {
  text-align: center;
  font-size: 14pt;
  border-style: inherit;
}

#errormessage {
  font-size: 18px;
  font-weight: 600;
  color: rgb(214, 214, 190);
  font-style: oblique;
  width: 40%;
  display: inline-block;
  margin-top: 20px;
}

#redirect_loader {
  font-size: 20px;
  font-weight: 800;
  color: rgb(214, 214, 190);
  font-style: oblique;
  width: 100%;
  display: inline-block;
}

@media only screen and (max-width: 550px) {
  .main {
    width: 100%;
  }
  v-dialog {
    width: 80%;
  }
}

.btn-grad {
  margin: 35px;
  height: 50px;
  width: 200px;
  color: #ffffff;
  text-decoration: none;
  text-transform: unset !important;
  border-radius: 20px;
  font-weight: 900;
  box-shadow: 1px 1px 1px 1px #ffffff;
  background-image: linear-gradient(to bottom, #6dbe45 0%, #3b701e 100%);
}

.btn-grad i {
  max-width: 0;
  transition: max-width 0.5s;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
}

.btn-grad:hover i {
  max-width: 10rem;
  transition-delay: 0.1s;
}

.loader,
.loader:before,
.loader:after {
  background: #ffffff;
  -webkit-animation: load1 1s infinite ease-in-out;
  animation: load1 1s infinite ease-in-out;
  width: 1em;
  height: 2em;
}
.loader {
  color: #ffffff;
  text-indent: -9999em;
  margin: 40px auto;
  position: relative;
  font-size: 11px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loader:before,
.loader:after {
  position: absolute;
  top: 0;
  content: "";
}
.loader:before {
  left: -1.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 1.5em;
}
@-webkit-keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 2em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 3em;
  }
}
@keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 2em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 3em;
  }
}
</style>